import React from 'react';
import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { useTranslation } from '../../localization';
import { EmptyStateFill } from '../../themeDefinitions';

const StyledEmptyState = styled('div')(
  css({
    alignItems: 'flex-start',
    bg: EmptyStateFill,
    display: 'flex',
    fontWeight: 'bold',
    height: '100%',
    justifyContent: 'center',
    p: 3,
    position: 'absolute',
    width: '100%',
  }),
);

export const EmptyState = React.forwardRef((_, ref) => {
  const { t } = useTranslation();
  return <StyledEmptyState innerRef={ref}>{t('No results')}</StyledEmptyState>;
});
